import { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useHardwareCheck } from './useHardwareCheck'
import { HardwareCheckModal } from './HardwareCheckModal'

const LEVELS = {
    green: { color: '#50CD89', text: 'All OK' },
    amber: { color: '#FFC700', text: 'Needs a look' },
    red: { color: '#F1416C', text: 'Problem found' },
    unknown: { color: '#A1A5B7', text: 'Not checked' },
}

/**
 * Dashboard "Hardware Check" button for every logged-in operator. The status dot shows the
 * outcome of the last check. Loading the dashboard never reads the weighbridges (that could
 * clash with a live weight reading) — the operator presses the button to run a check.
 */
export function HardwareCheckButton() {
    const hc = useHardwareCheck()
    const [show, setShow] = useState(false)
    const { refreshStatus } = hc
    const level = LEVELS[hc.analysis.level] || LEVELS.unknown

    // Only fetches the last result; no hardware is touched on dashboard load.
    useEffect(() => {
        refreshStatus()
    }, [refreshStatus])

    return (
        <>
            <Button variant="light-primary" size="sm" className="d-inline-flex align-items-center"
                onClick={() => setShow(true)} title={`Hardware Check — ${level.text}`}>
                <span className="d-inline-block rounded-circle me-2"
                    style={{ width: 10, height: 10, backgroundColor: level.color, boxShadow: `0 0 0 3px ${level.color}33` }} />
                <i className="bi bi-cpu me-1" />
                Hardware Check
                <span className="text-muted fs-8 ms-2 d-none d-sm-inline">{level.text}</span>
            </Button>
            <HardwareCheckModal show={show} onHide={() => setShow(false)} hc={hc} />
        </>
    )
}
